const FOUNDATION_FUND_FAMILY_CODE = 'av-foundation-fund';

const getSchoolName = (fundData, fundFamilyCode) => (
  fundData[fundFamilyCode]?.general?.title
  || fundData[fundFamilyCode]?.fields?.fundFamilyDisplayName
  || fundFamilyCode
);

const sortCoreFundFamilyKeys = (fundData) => Object.keys(fundData).sort(
  (firstFundFamilyCode, secondFundFamilyCode) => {
    if (firstFundFamilyCode === FOUNDATION_FUND_FAMILY_CODE) {
      return -1;
    }
    if (secondFundFamilyCode === FOUNDATION_FUND_FAMILY_CODE) {
      return 1;
    }

    return getSchoolName(fundData, firstFundFamilyCode).localeCompare(
      getSchoolName(fundData, secondFundFamilyCode),
      'en',
      { sensitivity: 'base' },
    );
  },
);

export default sortCoreFundFamilyKeys;
